/**
 * Formateo de fechas de recogidas
 */

const ISO_SOLO_FECHA = /^\d{4}-\d{2}-\d{2}$/;

// Un ISO sin hora ("2026-08-18") lo parsea JS como medianoche UTC, no local, y al
// formatearlo después en local aparece una hora inventada que cambia con el huso
// (01:00 en Canarias, 02:00 en Madrid) y que al oeste de UTC retrocede un día.
// Añadirle la hora hace que se interprete como local, como el resto de formatos.
const normalizar = (texto) =>
    ISO_SOLO_FECHA.test(texto) ? `${texto}T00:00:00` : texto.replace(' ', 'T');

/**
 * Formatea una fecha a "DD/MM/AAAA HH:mm".
 * Acepta tanto el ISO de la API (`2026-08-18T18:54:00Z`) como el formato con espacio
 * que llega de MSoft en el seguimiento (`2026-08-18 18:54:00`). Las fechas no
 * informadas llegan como null.
 * @param {string|Date} valor - Fecha a formatear
 * @param {string} [vacio='—'] - Texto a devolver si no hay fecha
 * @returns {string} Fecha formateada, el texto de vacío o el valor original si no parsea
 */
export const formatearFechaHora = (valor, vacio = '—') => {
    if (!valor) {
        return vacio;
    }

    const fecha = valor instanceof Date
        ? valor
        : new Date(normalizar(String(valor)));

    if (Number.isNaN(fecha.getTime())) {
        return String(valor);
    }

    const dia = fecha.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
    const hora = fecha.toLocaleTimeString('es-ES', {
        hour: '2-digit',
        minute: '2-digit',
    });

    return `${dia} ${hora}`;
};
